const api = "https://gemnomads.buildzone.net/live/graphql/";
const diamondListingApi = "diamondData";
const diamondDetailApi = "diamondById";
const diamondpairListingApi = "devPairDiamondData";
const diamondpairDetailApi = "devPairDiamondById";
const diamondSearchByReportApi = "diamondByStockorcert";
const diamondAddToCart = "diamondAddToCart";
const pendantAddToCart = "pendentAddToCart";
const ringAddToCart = "ringAddToCart";
const productMetafield = "productMetafield";
const earringAddToCart = "earringAddToCart";
var currencyCode = jQuery("#tps-currency-symbol").val();
var availableCurrencies = ['USD'];
var currencySymbol = getCurrenySymbol(currencyCode);

/*** get currency symbol start ***/
function getCurrenySymbol(CurrenyCode) {
	var currency_symbol;
	switch (CurrenyCode) {
		case 'USD':
			currency_symbol = '$';
			break;
        case 'GBP':
			currency_symbol = '£';
			break;
		default:
			currency_symbol = '$';
	}
	return currency_symbol;
}
/*** get currency symbol end ***/

/*** addCommas in price start ***/
function addCommas(price) {
  price += '';
  x = price.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}
/*** addCommas in price end ***/

/*** set selected filters for session filters after reloading page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {      
	if (input_value == 'price') {
		$('.selected_filter_container').find('li[data-input="price"]').remove();
	}else if (input_value == 'carat') {
		$('.selected_filter_container').find('li[data-input="carat"]').remove();
	}else if (input_value == 'depth') {
		$('.selected_filter_container').find('li[data-input="depth"]').remove();
	}else if (input_value == 'table') {
		$('.selected_filter_container').find('li[data-input="table"]').remove();
	}else if (input_value == 'color') {
		$('.selected_filter_container').find('li[data-input="color"]').remove();
	}else if (input_value == 'clarity') {
		$('.selected_filter_container').find('li[data-input="clarity"]').remove();
	}else if (input_value == 'intensity') {
		$('.selected_filter_container').find('li[data-input="intensity"]').remove();
	}else if (input_value == 'cut') {
		$('.selected_filter_container').find('li[data-input="cut"]').remove();
	}else if (input_value == 'fluorescence') {
		$('.selected_filter_container').find('li[data-input="fluorescence"]').remove();
	}else if (input_value == 'polish') {
		$('.selected_filter_container').find('li[data-input="polish"]').remove();
	}else if (input_value == 'symmetry') {
		$('.selected_filter_container').find('li[data-input="symmetry"]').remove();
	}

	var value = filter_value.split(':');
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();
         if(input_value == 'price' && input_value != 'carat' && input_value != 'depth' && input_value != 'table' && input_value != 'cut' && input_value != 'polish' && input_value != 'symmetry' && input_value != 'fluorescence' && input_value != 'clarity' && input_value != 'color' && input_value != 'intensity') {
           //filter_lable = filter_lable.replace(/\-/g, ' ');
         }
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps_filter_values">' + filter_lable + '<span class="tps-pendantbuilder-remove-option"></span></div></li>';
		if ($('#' + value[0] + '_container').length > 0) {
			$('#' + value[0] + '_container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '_container"><span class="tps_applied_filter_lable">' + value[0] + ':</span></ul>';
			$('.selected_filter_container').append(elecontainer);
			$('#' + value[0] + '_container').append(html);
		}      
	} else {
		$('.selected_filter_container').find('li[data-filter_value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '_container li').length == 0) {
			$('#' + value[0] + '_container').remove();
		}
	}
	if ($('.selected_filter_container li').length > 0) {
		$('.tps_selected_filter_wrapper').show();
	} else {
		$('.tps_selected_filter_wrapper').hide();
	}
}
/*** set selected filters for session filters after reloading page end ***/

/*** tps config function to get urls start ***/
var tps_config = {
  "urls": {        
    "ring_builder_listing": "/collections/build-your-own-ring",		
    "ringbuilder_natural_white_diamond_listing": "/pages/ringbuilder-natural-white-diamonds",
    "ringbuilder_lab_white_diamond_listing": "/pages/ringbuilder-lab-white-diamonds",
    "ringbuilder_natural_colored_diamond_listing": "/pages/ringbuilder-natural-colored-diamonds",
    "ringbuilder_lab_colored_diamond_listing": "/pages/ringbuilder-lab-colored-diamonds",
    "ringbuilder_diamond_detail": "/pages/ringbuilder-diamond-details",
    "ring_builder_final_page": "/pages/final-ring",
  }
}
/*** tps config function to get urls end ***/

/*** Diamond Carat Filter Start ***/
var minDiamondCarat = parseFloat($('#diamondMincarat').val());
//alert(minDiamondCarat);
var maxDiamondCarat = parseFloat($('#diamondMaxcarat').val());
var carat = [];
/* Carat Calibreation Start*/ 
for (i = minDiamondCarat; i < 1; i = i + 0.01) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 2; i = i + 0.05) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 2; i < 3; i = i + 0.10) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 3; i < maxDiamondCarat; i = i + 0.15) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
/* Carat Calibreation End*/ 
carat.push(maxDiamondCarat);
Shopify.money_format = '&pound;{{amount}}';
var currency_symbol = "£";


function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}

function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}

function carat_slider_render(start, end, option) { 
    var start2 = getClosestNum(start, carat);
	var end2 = getClosestNum(end, carat);   
	var start1 = get_index(start2, carat);
	var start11 = get_index(start, carat);
	var end11 = get_index(end, carat);
	var end1 = get_index(end2, carat);
  
	var settingSelected = jQuery("#setting").val();

    var pendant_setting = localStorage.getItem("pendant_setting");
    var ring_setting = localStorage.getItem("ring_setting");

    var min_carat = parseFloat($("#diamondMincarat").val()).toFixed(2);
    var max_carat = parseFloat($("#diamondMaxcarat").val()).toFixed(2);

    if (window.location.href.indexOf('ringbuilder-natural-white-diamonds') > 0 || window.location.href.indexOf('ringbuilder-lab-white-diamonds') > 0 || window.location.href.indexOf('ringbuilder-natural-colored-diamonds') > 0 || window.location.href.indexOf('ringbuilder-lab-colored-diamonds') > 0) {
       if(localStorage.getItem("ring_setting") != null){
          var ringsetting_details = jQuery.parseJSON(ring_setting);
          var min_carat = ringsetting_details[0].minimum_carat_total_weight;
          var max_carat = ringsetting_details[0].maximum_carat_total_weight;
          var isSelected = true;
       }
    }else if (window.location.href.indexOf('pendant-builder-diamond-listing') > 0) {
        if(localStorage.getItem("pendant_setting") != null){
          var setting_details = jQuery.parseJSON(pendant_setting);
          var min_carat = setting_details[0].minimum_carat_total_weight;
          var max_carat = setting_details[0].maximum_carat_total_weight;  
        }        
    }
  
     //session carat filter selected
     var isSelected = false;
     if(parseFloat(start).toFixed(2) != min_carat || parseFloat(end).toFixed(2) != max_carat){
       isSelected = true;
     }  
       
     var caratTitle = 'Carat: '+start + ' ct.'+' - '+end + ' ct.';
     setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
     //end
  
	jQuery("#carat-slider").slider({      
		range: true,
		min: 0,
		max: carat.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {  
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			//disable min max slider if setting selected
			if (settingSelected == 1 && (parseFloat(start) > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(end) < parseFloat(carat[parseInt(ui.values[1])]))) {
				return false;
			}
          
			$("#carat_from").val(carat[parseInt(ui.values[0])] + ' ct.');
			$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
			$('#carat_to').val(carat[parseInt(ui.values[1])] + ' ct.');
			$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {  
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');               

                //applied filter code start here                              
                 var isSelected = false;                        
                 if(carat[parseInt(ui.values[0])] != min_carat || carat[parseInt(ui.values[1])] != max_carat){
                       isSelected = true;
                 }else if(localStorage.getItem("ring_setting") != null){                   
                   if(carat[parseInt(ui.values[0])] == min_carat || carat[parseInt(ui.values[1])] == max_carat){                    
                     isSelected = true;
                   }                   
                 }

                setTimeout(function(){  
                    var caratLeft = $('#carat_left_hidden').val();
                    var caratRight = $('#carat_right_hidden').val();
                    var caratTitle = 'Carat: '+caratLeft+ ' ct.'+' - '+caratRight+ ' ct.';
                    //var caratTitle = 'Carat: '+start+ ' ct.'+' - '+end+ ' ct.';
                    setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
                    //end 
                    graphqlDataCall();
                }, 20);
    			               
			}
           
		}

	});

    
    start = start ? start : minDiamondCarat;
    $("#carat_from").val(start + ' ct.');
    $("#carat_to").val(end + ' ct.');
    $('#carat_left_hidden').val(start);
    $('#carat_right_hidden').val(end);
    
}


function replace_carat_from() {

	var min_carat_value = minDiamondCarat;
 
	var settingSelected = jQuery("#setting").val();
  

	if (jQuery('#carat_from').val() == '') {
		var value = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2);
		jQuery('#carat_from').val(parseFloat(value).toFixed(2) + ' ct.');
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_from').val()).toFixed(2);
	}
	
	var value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_to').val());
	if (isNaN(value) != false) {
		var value = parseFloat(minDiamondCarat).toFixed(2);
		alert("Please enter value in number");
		jQuery('#carat_from').val(value + ' ct.');
	} else if (value > value1) {
		alert('Incorrect carat range!');
		$('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2) + ' ct.');
		return false;
	} else if (carat_value < min_carat_value) {
		alert('Incorrect carat range!');
		$('#carat_from').val((parseFloat(min_carat_value).toFixed(2)) + " ct.");
		carat_slider_render(min_carat_value, value1, true);
		return false;
	} else if (settingSelected == 1 && (hidden_carat_value > carat_value)) {
		alert('selected setting can match with diamond greater than ' + carat_value);
		jQuery('#carat_from').val(hidden_carat_value + " ct.");
		return false;
	}
	$('#carat_left_hidden').val(value);
	$('#carat_right_hidden').val(value1);

	carat_slider_render(value, value1, true);

}

function replace_carat_to() {
	var max_carat_value = parseFloat(maxDiamondCarat).toFixed(2);
	var settingSelected = jQuery("#setting").val();
	if (jQuery('#carat_to').val() == '') {
		var value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		jQuery('#carat_to').val(parseFloat(value).toFixed(2) + ' ct.');
		return false;
	} else {
		var hidden_carat_value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_to').val()).toFixed(2);
	}

	value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_from').val());
    
	if (isNaN(value) != false) {
		var value = parseFloat(maxDiamondCarat).toFixed(2);
		alert("Please enter value in number");
		jQuery('#carat_to').val(value + ' ct.');
	} else if (parseFloat(value) > parseFloat(max_carat_value)) {
		alert('Incorrect carat range!');
		jQuery('#carat_to').val(hidden_carat_value + " ct.");
		return false;
	} else if (value1 > value) {
		alert('Incorrect carat range!');
		$('#carat_to').val(hidden_carat_value + ' ct.');
		return false;
	}else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
		alert('Selected setting can match with diamond less than ' + carat_value);
		jQuery('#carat_to').val(hidden_carat_value + " ct.");
		return false;
	}
   
	$('#carat_right_hidden').val(value);
	$('#carat_left_hidden').val(value1);

	carat_slider_render(value1, value, true);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
var price = [];
var minDiamondPrice = parseFloat($('#diamondMinprice').val());
var maxDiamondPrice = parseFloat($('#diamondMaxprice').val());

for (var i = parseInt($('#diamondMinprice').val()); i < 5000; i = i+1) {
  price.push(i);
};
for (var i = 5000; i < 7000; i = i+10) {
  price.push(i);
};
for (var i = 7000; i < 10000; i = i+20) {
  price.push(i);
};
for (var i = 10000; i < 15000; i = i+25) {
  price.push(i);
};
for (var i = 15000; i < 25000; i = i+200) {
  price.push(i);
};
for (var i = 25000; i < 300000; i = i+300) {
  price.push(i);
};


price.push(parseInt(maxDiamondPrice));

function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
var diamondMinprice = $('#diamondMinprice').val();
var diamondMaxprice = $('#diamondMaxprice').val();

function price_slider_render(start, end, option) {

    var start2=getClosestNum(start,price);
    var end2=getClosestNum(end,price);  
    var start1=get_priceindex(start2); 
    var start11=get_priceindex(start);
    var end11=get_priceindex(end);
    var end1=get_priceindex(end2); 

     //session price filter selected
     var isSelected = false;
     if(start != diamondMinprice || end != diamondMaxprice){
       isSelected = true;
     }

    var priceTitle = 'Price: '+Shopify.formatMoney(start*100, theme.moneyFormat)+' - '+Shopify.formatMoney(end*100, theme.moneyFormat);
     //var priceTitle = 'Price: '+currencySymbol+addCommas(start)+' - '+currencySymbol+addCommas(end);
 
    setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
    //end
  
   jQuery('#price-slider').slider({
       range: true,
       // values: [start, end],
       // min: Number(diamondMinprice),
       // max: Number(diamondMaxprice),
       //step: 1,
         min: 0,
         max: price.length-1,
         values: [ start1,end1 ],
         step:0.1,
       slide: function (event, ui) {
       // emptyResultDiv();
         
         if ((ui.values[0]) > (ui.values[1])) { 
            return false; 
        }
          jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
          jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
         
          var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
          jQuery('#price_from').val(price_form);
          var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
          jQuery('#price_to').val(price_to);
         
          option = true;
       }, change: function (event, ui) {
         if(option == true) {
           emptyResultDiv();
           
           jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
           jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
           var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
           jQuery('#price_from').val(price_form);

           var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
           jQuery('#price_to').val(price_to);      
  
           //applied filters 
           var isSelected = false;
           if(price[parseInt(ui.values[0])] != diamondMinprice || price[parseInt(ui.values[1])] != diamondMaxprice){
              isSelected = true;
           } 
           
           var priceTitle = 'Price: '+price_form+' - '+price_to;
           setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
          //end

           jQuery('#page_no').val(1);
    	   jQuery('#pagination').val('');
           
            graphqlDataCall();
           return false;
         }else if(option == false){ 
             jQuery('#price_left_hidden').val(start);
             jQuery('#price_right_hidden').val(end);

             var price_form = ""+Shopify.formatMoney(start*100, theme.moneyFormat);
             jQuery('#price_from').val(price_form);
             var price_to = ""+Shopify.formatMoney(end*100, theme.moneyFormat);
             jQuery('#price_to').val(price_to);

             jQuery('#page_no').val(1);
             jQuery('#pagination').val('');
          
             graphqlDataCall();     
             option = true;
             return false;
         }
       
       }
     });

    var start_num = parseInt(start);
	var end_num = parseInt(end);

	var start_dec = start_num.toFixed(0);
	var end_dec = end_num.toFixed(0);

	jQuery('#price_left_hidden').val(start_dec);
	jQuery('#price_right_hidden').val(end_dec);
	jQuery('#price_from').val(currencySymbol + " " + addCommas(start_dec));
	jQuery('#price_to').val(currencySymbol + " " + addCommas(end_dec));
}

function get_priceindex(value) {
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}

/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_to() {

	if (jQuery('#price_to').val() == '') {
		var value = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		//jQuery('#price_to').val(currency_symbol + " " + numberWithCommas(value.toFixed(0)));
       jQuery('#price_to').val(formatted_price); 
		return false;
	} else {
		var value = jQuery('#price_to').val();
        value = value.replace('£', '');
	}

	//var value1 = jQuery('#price_from').val();
   var value1 = jQuery('#price_left_hidden').val();
  
	value=value.replace(/[^\d\.]/g, '');
    value1=value1.replace(/[^\d\.]/g, '');

	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value) != false) {
		var value = maxDiamondPrice;
		alert("Please enter value in number");
		jQuery('#1000000').val(currency_symbol + value);
	} else if (value > maxDiamondPrice) {        
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		//jQuery('#price_to').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
        jQuery('#price_to').val(formatted_price);   
		return false;
	} else if (value1 > value) {      
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		//jQuery('#price_to').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
      jQuery('#price_to').val(formatted_price); 
		return false;
	} else if (value1 == '') {
		jQuery('#price_from').val(value1);
	}

	jQuery('#price_right_hidden').val(value.toFixed(0));
	jQuery('#price_left_hidden').val(value1.toFixed(0));
	price_slider_render(value1, value, false);

}

function replace_price_from() {
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		//jQuery('#price_from').val(currency_symbol + "" + numberWithCommas(value.toFixed(0)));
       jQuery('#price_from').val(formatted_price);
		return false;
	} else {
		var value = jQuery('#price_from').val();
        value = value.replace('£', '');
	}
	//var value1 = jQuery('#price_to').val();
    var value1 = jQuery('#price_right_hidden').val();

    value=value.replace(/[^\d\.]/g, '');
    value1=value1.replace(/[^\d\.]/g, '');

	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value) != false) {
		var value = minDiamondPrice;
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		alert("Please enter value in number");
        jQuery('#price_from').val(formatted_price);
		//jQuery('#price_from').val(currency_symbol + value);
	} else if (value < minDiamondPrice) {
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_left_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
        jQuery('#price_from').val(formatted_price);
		//jQuery('#price_from').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
		return false;
	} else if (value > value1) {
		alert('Incorrect price range!');
		price_slider_render(price[0], value1, false);
		return false;
	}

	jQuery('#price_left_hidden').val(value.toFixed(0));
	jQuery('#price_right_hidden').val(value1.toFixed(0));
	price_slider_render(value, value1, false);

}
/*** Diamond Price Filter End ***/

/*** Diamond Depth Filter Start ***/
var depth = [];
var depthSliderDefaultMin = parseFloat(jQuery("#depth-slider-default-min").val());
var depthSliderDefaultMax = parseFloat(jQuery("#depth-slider-default-max").val());
for (i = depthSliderDefaultMin; i < depthSliderDefaultMax; i = i + 0.10) {
	var dec = i.toFixed(2);
	depth.push(dec);
}
function depth_slider_render(start, end, option) { 
	var start2 = getClosestNum(start, depth);
	var end2 = getClosestNum(end, depth);
	var start1 = get_index(start2, depth);
	var start11 = get_index(start, depth);
	var end11 = get_index(end, depth);
	var end1 = get_index(end2, depth);

     //session depth filter selected
     var isSelected = false;      
     if(parseInt(start) != parseInt(depthSliderDefaultMin) || parseInt(end) != parseInt(depthSliderDefaultMax)){
       isSelected = true;
     }

     var depthTitle = 'Depth: '+start+' % - '+end+' %';
     setSelectedFilter(depthTitle,"depth_slider_render('"+depthSliderDefaultMin+"', '"+depthSliderDefaultMax+"','true')",isSelected,'depth');
     //end
  
	jQuery("#depth-slider").slider({
		range: true,
		min: 0,
		max: depth.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
			$("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
			if (option) {
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');	

                $("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
    			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
    			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
    			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);

                 //applied filter start
                 var isSelected = false;               
                 if(depth[parseInt(ui.values[0])] != parseInt(depthSliderDefaultMin) || depth[parseInt(ui.values[1])] != parseInt(depthSliderDefaultMax)){
                       isSelected = true;
                 }
                var depthTitle = 'Depth: '+depth[parseInt(ui.values[0])] + ' %'+' - '+depth[parseInt(ui.values[1])] + ' %';
                setSelectedFilter(depthTitle,"depth_slider_render('"+depthSliderDefaultMin+"', '"+depthSliderDefaultMax+"','true')",isSelected,'depth');
    			
            }
            //end
            
            graphqlDataCall();
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#depth_from").val(Start_limit.toFixed(2) + '%');
	$("#depth_to").val(End_limit.toFixed(2) + '%');
	$('#depth_left_hidden').val(start);
	$('#depth_right_hidden').val(end);
}

function replace_depth_from() {
	if (jQuery('#depth_from').val() == '') {
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_from').val());
		var hidden_depth_value = $('#depth_left_hidden').val();
	}
	
	var value = depth_value;
	
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_to').val());
	
	if (isNaN(value) != false) {
		var value = depthSliderDefaultMin;
		alert("Please enter value in number");
		jQuery('#depth_from').val(value + '%');
	} else if (value > value1) {
		alert('Incorrect depth range!');
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (depth_value < depthSliderDefaultMin) {
		alert('Incorrect depth range!');
		$('#depth_from').val(depthSliderDefaultMin + "%");
		depth_slider_render(depthSliderDefaultMin, value1, true);
		return false;
	}

	$('#depth_left_hidden').val(value);
	$('#depth_right_hidden').val(value1);

	depth_slider_render(value, value1, true);
}

function replace_depth_to() {
	if (jQuery('#depth_to').val() == '') {
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_to').val());
		var hidden_depth_value = $('#depth_right_hidden').val();
	}	
	value = depth_value;
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_from').val());

	if (isNaN(value) != false) {
		var value = depthSliderDefaultMax;
		alert('Please enter value in number');
		jQuery('#depth_to').val(value + '%');
	} else if (value1 > value) {
		alert('Incorrect depth range!');
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > depthSliderDefaultMax) {
		alert('Incorrect depth range!');
		$('#depth_to').val(depthSliderDefaultMax + "%");
		depth_slider_render(value1, depthSliderDefaultMax, true);
		return false;
	}

	$('#depth_right_hidden').val(value);
	$('#depth_left_hidden').val(value1);

	depth_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/*** Diamond Table Filter Start ***/
var table = [];
var tableSliderDefaultMin = parseFloat(jQuery("#table-slider-default-min").val());
var tableSliderDefaultMax = parseFloat(jQuery("#table-slider-default-max").val());
for (i = tableSliderDefaultMin; i < tableSliderDefaultMax; i = i + 0.10) {
	var dec = i.toFixed(2);
	table.push(dec);
}
function table_slider_render(start, end, option) {
	var start2 = getClosestNum(start, table);
	var end2 = getClosestNum(end, table);
	var start1 = get_index(start2, table);
	var start11 = get_index(start, table);
	var end11 = get_index(end, table);
	var end1 = get_index(end2, table);

    //session depth filter selected
     var isSelected = false;
     if(start != parseInt(tableSliderDefaultMin) || end != parseInt(tableSliderDefaultMax)){
       isSelected = true;
     }

     var tableTitle = 'Table: '+start+' % - '+end+' %';
     setSelectedFilter(tableTitle,"table_slider_render('"+parseInt(tableSliderDefaultMin)+"', '"+parseInt(tableSliderDefaultMax)+"','true')",isSelected,'table');
     //end
  
	jQuery("#table-slider").slider({
		range: true,
		min: 0,
		max: table.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#table_from").val(table[parseInt(ui.values[0])] + '%');
			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
			if (option) {
				if (option == true) {
					jQuery('#page_no').val(1);
					jQuery('#pagination').val('');					

                    $("#table_from").val(table[parseInt(ui.values[0])] + '%');
        			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
        			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
        			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
                 
                    //applied filter start
                     var isSelected = false;
                     if(table[parseInt(ui.values[0])] != tableSliderDefaultMin || table[parseInt(ui.values[1])] != tableSliderDefaultMax){
                           isSelected = true;
                     }
                    var tableTitle = 'Table: '+table[parseInt(ui.values[0])] + ' %'+' - '+table[parseInt(ui.values[1])] + ' %';
                    setSelectedFilter(tableTitle,"table_slider_render('"+tableSliderDefaultMin+"', '"+tableSliderDefaultMax+"','true')",isSelected,'table');

                    graphqlDataCall();
				}


			}
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#table_from").val(Start_limit.toFixed(2) + '%');
	$("#table_to").val(End_limit.toFixed(2) + '%');

	$('#table_left_hidden').val(start);
	$('#table_right_hidden').val(end);
}

function replace_table_from() {
	if (jQuery('#table_from').val() == '') {
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_from').val());
		var hidden_table_value = $('#table_left_hidden').val();
	}
	
	var value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_to').val());
	
	if (isNaN(value) != false) {
		var value = tableSliderDefaultMin;
		alert('Please enter value in number');
		jQuery('#table_from').val(value + '%');
	} else if (value > value1) {
		alert('Incorrect table range!');
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (table_value < tableSliderDefaultMin) {
		alert('Incorrect table range!');
		$('#table_from').val(tableSliderDefaultMin + "%");
		table_slider_render(tableSliderDefaultMin, value1, true);
		return false;
	}

	$('#table_left_hidden').val(value);
	$('#table_right_hidden').val(value1);

	table_slider_render(value, value1, true);
}

function replace_table_to() {
	if (jQuery('#table_to').val() == '') {
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_to').val());
		var hidden_table_value = $('#table_right_hidden').val();
	}

	value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_from').val());
	
	if (isNaN(value) != false) {
		var value = tableSliderDefaultMax;
		alert('Please enter value in number');
		jQuery('#table_to').val(value + '%');
	} else if (value1 > value) {
		alert('Incorrect table range!');
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > tableSliderDefaultMax) {
		$('#table_to').val(tableSliderDefaultMax + "%");
		table_slider_render(value1, tableSliderDefaultMax, true);
		return false;
	}

	$('#table_right_hidden').val(value);
	$('#table_left_hidden').val(value1);

	table_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/


/************************** Start - Diamond Color Filter **************************/
function color_slider_render(start,end,option){
  var colorHeadTitle = 'Color:';
  var colorSliderDefaultMax = jQuery("#color-slider-default-max").val();  
  //session color filter selected
  var isSelected = false;
  if(start != 0 || end != colorSliderDefaultMax){
    isSelected = true;
  }
  var selected_values = getFilterValues(min_color,max_color,'color');
  if(selected_values[0] == selected_values[1]){
    var colorTitle = colorHeadTitle+' '+selected_values[1];
  }else{
    var colorTitle = colorHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }
  setSelectedFilter(colorTitle,"color_slider_render('0', "+colorSliderDefaultMax+",'false')",isSelected,'color');
  //end
  
  jQuery( "#color_range" ).slider({ 
    range: true,
    values: [start, end],
    min: 0,
    max: colorSliderDefaultMax,
    step: 1, 
    slide: function( event, ui ) {          
      if ((ui.values[0]) >= (ui.values[1])) {
        return false;
      }               
      jQuery( "#color-min-value" ).val(ui.values[0]);
      jQuery( "#color-max-value" ).val(ui.values[1]);             
    },
    change: function( event, ui ) {  
      emptyResultDiv();          
      jQuery( "#color-min-value" ).val(ui.values[0]);
      jQuery( "#color-max-value" ).val(ui.values[1]);          
      //applied filters 
      var isSelected = false;         
      if(ui.values[0] != 0 || ui.values[1] != colorSliderDefaultMax){
        isSelected = true;
      }          
      var selected_values = getFilterValues(ui.values[0],ui.values[1],'color');            
      if(selected_values[0] == selected_values[1]){
        var colorTitle = colorHeadTitle+' '+selected_values[1];    
      }else{
        var colorTitle = colorHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
      }
      setSelectedFilter(colorTitle,"color_slider_render('0', "+colorSliderDefaultMax+",'false')",isSelected,'color');
      //end          
      jQuery('#page_no').val(1);
      jQuery('#pagination').val('');
      graphqlDataCall();
      return false;
    }
  });
}
/************************** End - Diamond Color Filter **************************/

/************************** Start - Diamond clarity Filter **************************/
function clarity_slider_render(start,end,option){
  var clarityHeadTitle = 'Clarity:';
  var claritySliderDefaultMax = jQuery("#clarity-slider-default-max").val();
  //session clarity filter selected
  var isSelected = false;
  if(start != 0 || end != claritySliderDefaultMax){
     isSelected = true;
  }
  var selected_values = getFilterValues(min_clarity,max_clarity,'clarity');
  if(selected_values[0] == selected_values[1]){
    var clarityTitle = clarityHeadTitle+' '+selected_values[1];
  }else{
    var clarityTitle = clarityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }
  setSelectedFilter(clarityTitle,"clarity_slider_render('0', "+claritySliderDefaultMax+",'false')",isSelected,'clarity');
  //end

  jQuery( "#clarity_range" ).slider({ 
    range: true,
    values: [start, end],
    min: 0,
    max: claritySliderDefaultMax,
    step: 1, 
    slide: function( event, ui ) {          
      if ((ui.values[0]) >= (ui.values[1])) {
        return false;
      }         
      jQuery( "#clarity-min-value" ).val(ui.values[0]);
      jQuery( "#clarity-max-value" ).val(ui.values[1]);
    },
    change: function( event, ui ) {  
      emptyResultDiv();      
      jQuery( "#clarity-min-value" ).val(ui.values[0]);
      jQuery( "#clarity-max-value" ).val(ui.values[1]);      
      //applied filters 
      var isSelected = false;         
      if(ui.values[0] != 0 || ui.values[1] != claritySliderDefaultMax){
        isSelected = true;
      }          
      var selected_values = getFilterValues(ui.values[0],ui.values[1],'clarity');            
      if(selected_values[0] == selected_values[1]){
        var clarityTitle = clarityHeadTitle+' '+selected_values[1];    
      }else{
        var clarityTitle = clarityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
      }
      setSelectedFilter(clarityTitle,"clarity_slider_render('0', "+claritySliderDefaultMax+",'false')",isSelected,'clarity');
      //end          
      jQuery('#page_no').val(1);
      jQuery('#pagination').val('');
      graphqlDataCall();
      return false;
    }
  });
}
/************************** End - Diamond clarity Filter **************************/

/************************** Start - Diamond Cut Filter **************************/
function cut_slider_render(start,end,option){  
  var cutHeadTitle = 'Cut:';
  var cutSliderDefaultMax = jQuery("#cut-slider-default-max").val();  
  //session cut filter selected
  var isSelected = false;
  if(start != 0 || end != cutSliderDefaultMax){
     isSelected = true;
  }  
  var selected_values = getFilterValues(min_cut,max_cut,'cut');  
  if(selected_values[0] == selected_values[1]){
    var cutTitle = cutHeadTitle+' '+selected_values[1];
  }else{
    var cutTitle = cutHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }  
  setSelectedFilter(cutTitle,"cut_slider_render('0', "+cutSliderDefaultMax+",'false')",isSelected,'cut');
  //end
  
  jQuery( "#cut_range" ).slider({ 
    range: true,
    values: [start, end],
    min: 0,
    max: cutSliderDefaultMax,
    step: 1, 
    slide: function( event, ui ) {          
      if ((ui.values[0]) >= (ui.values[1])) {
        return false;
      }         
      jQuery( "#cut-min-value" ).val(ui.values[0]);
      jQuery( "#cut-max-value" ).val(ui.values[1]);
    },
    change: function( event, ui ) {  
      emptyResultDiv();      
      jQuery( "#cut-min-value" ).val(ui.values[0]);
      jQuery( "#cut-max-value" ).val(ui.values[1]);        
      //applied filters 
      var isSelected = false;         
      if(ui.values[0] != 0 || ui.values[1] != cutSliderDefaultMax){
        isSelected = true;
      }          
      var selected_values = getFilterValues(ui.values[0],ui.values[1],'cut');          
      if(selected_values[0] == selected_values[1]){
        var cutTitle = cutHeadTitle+' '+selected_values[1];    
      }else{
        var cutTitle = cutHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
      }   
      setSelectedFilter(cutTitle,"cut_slider_render('0', "+cutSliderDefaultMax+",'false')",isSelected,'cut');
      //end        
      jQuery('#page_no').val(1);
      jQuery('#pagination').val('');
      graphqlDataCall();
      return false;
    }
  });
}
/************************** End - Diamond Cut Filter **************************/

/************************** Start - Diamond intensity Filter **************************/
function intensity_slider_render(start,end,option){
  var intensityHeadTitle = 'Intensity:';  
  var intensitySliderDefaultMax = jQuery("#intensity-slider-default-max").val();
  //session intensity filter selected
  var isSelected = false;
  if(start != 0 || end != intensitySliderDefaultMax){
     isSelected = true;
  }
  var selected_values = getFilterValues(min_intensity,max_intensity,'intensity');
  if(selected_values[0] == selected_values[1]){
    var intensityTitle = intensityHeadTitle+' '+selected_values[1];
  }else{
    var intensityTitle = intensityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }
  setSelectedFilter(intensityTitle,"intensity_slider_render('0', "+intensitySliderDefaultMax+",'false')",isSelected,'intensity');
  //end

  jQuery( "#intensity_range" ).slider({ 
    range: true,
    values: [start, end],
    min: 0,
    max: intensitySliderDefaultMax,
    step: 1, 
    slide: function( event, ui ) {          
      if ((ui.values[0]) >= (ui.values[1])) {
        return false;
      }         
      jQuery( "#intensity-min-value" ).val(ui.values[0]);
      jQuery( "#intensity-max-value" ).val(ui.values[1]);
    },
    change: function( event, ui ) {  
      emptyResultDiv();      
      jQuery( "#intensity-min-value" ).val(ui.values[0]);
      jQuery( "#intensity-max-value" ).val(ui.values[1]);      
      //applied filters 
      var isSelected = false;         
      if(ui.values[0] != 0 || ui.values[1] != intensitySliderDefaultMax){
        isSelected = true;
      }          
      var selected_values = getFilterValues(ui.values[0],ui.values[1],'intensity');            
      if(selected_values[0] == selected_values[1]){
        var intensityTitle = intensityHeadTitle+' '+selected_values[1];    
      }else{
        var intensityTitle = intensityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
      }
      setSelectedFilter(intensityTitle,"intensity_slider_render('0', "+intensitySliderDefaultMax+",'false')",isSelected,'intensity');
      //end          
      jQuery('#page_no').val(1);
      jQuery('#pagination').val('');
      graphqlDataCall();
      return false;
    }
  });
}
/************************** End - Diamond intensity Filter **************************/

/************************** Start - Diamond fluorescence Filter **************************/
function fluorescence_slider_render(start,end,option){
  var fluorescenceHeadTitle = 'Flourescence:';
  var flourescenceSliderDefaultMax = jQuery("#flourescence-slider-default-max").val();
  //session fluorescence filter selected
  var isSelected = false;
  if(start != 0 || end != flourescenceSliderDefaultMax){
     isSelected = true;
  }
  var selected_values = getFilterValues(min_fluorescence,max_fluorescence,'fluorescence');
  if(selected_values[0] == selected_values[1]){
    var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[1];
  }else{
    var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }
  setSelectedFilter(fluorescenceTitle,"fluorescence_slider_render('0', "+flourescenceSliderDefaultMax+",'false')",isSelected,'fluorescence');
  //end

  jQuery( "#fluorescence_range" ).slider({ 
    range: true,
    values: [start, end],
    min: 0,
    max: flourescenceSliderDefaultMax,
    step: 1, 
    slide: function( event, ui ) {          
      if ((ui.values[0]) >= (ui.values[1])) {
        return false;
      }         
      jQuery( "#fluorescence-min-value" ).val(ui.values[0]);
      jQuery( "#fluorescence-max-value" ).val(ui.values[1]);
    },
    change: function( event, ui ) {  
      emptyResultDiv();          
      jQuery( "#fluorescence-min-value" ).val(ui.values[0]);
      jQuery( "#fluorescence-max-value" ).val(ui.values[1]);          
      //applied filters 
      var isSelected = false;         
      if(ui.values[0] != 0 || ui.values[1] != flourescenceSliderDefaultMax){
        isSelected = true;
      }          
      var selected_values = getFilterValues(ui.values[0],ui.values[1],'fluorescence');      
      if(selected_values[0] == selected_values[1]){
        var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[1];    
      }else{
        var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
      }
      setSelectedFilter(fluorescenceTitle,"fluorescence_slider_render('0', "+flourescenceSliderDefaultMax+",'false')",isSelected,'fluorescence');
      //end      
      jQuery('#page_no').val(1);
      jQuery('#pagination').val('');
      graphqlDataCall();
      return false;
    }
  });
}
/************************** End - Diamond fluorescence Filter **************************/
  
/************************** Start - Diamond Polish Filter **************************/
function polish_slider_render(start,end,option){
  var polishHeadTitle = 'Polish:';  
  var polishSliderDefaultMax = jQuery("#polish-slider-default-max").val();
  //session Polish filter selected
  var isSelected = false;
  if(start != 0 || end != polishSliderDefaultMax){
     isSelected = true;
  }
  var selected_values = getFilterValues(min_polish,max_polish,'polish');
  if(selected_values[0] == selected_values[1]){
    var polishTitle = polishHeadTitle+' '+selected_values[1];
  }else{
    var polishTitle = polishHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }
  setSelectedFilter(polishTitle,"polish_slider_render('0', "+polishSliderDefaultMax+",'false')",isSelected,'polish');
  //end

  jQuery( "#polish_range" ).slider({ 
    range: true,
    values: [start, end],
    min: 0,
    max: polishSliderDefaultMax,
    step: 1, 
	slide: function( event, ui ) {          
      if ((ui.values[0]) >= (ui.values[1])) {
        return false;
      }         
      jQuery( "#polish-min-value" ).val(ui.values[0]);
      jQuery( "#polish-max-value" ).val(ui.values[1]);
	},
	change: function( event, ui ) {  
      emptyResultDiv();      
      jQuery( "#polish-min-value" ).val(ui.values[0]);
      jQuery( "#polish-max-value" ).val(ui.values[1]);	        
      //applied filters 
      var isSelected = false;         
      if(ui.values[0] != 0 || ui.values[1] != polishSliderDefaultMax){
        isSelected = true;
      }          
      var selected_values = getFilterValues(ui.values[0],ui.values[1],'polish');      
      if(selected_values[0] == selected_values[1]){
        var polishTitle = polishHeadTitle+' '+selected_values[1];    
      }else{
        var polishTitle = polishHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
      }       
      setSelectedFilter(polishTitle,"polish_slider_render('0', "+polishSliderDefaultMax+",'false')",isSelected,'polish');
      //end      
      jQuery('#page_no').val(1);
      jQuery('#pagination').val('');
      graphqlDataCall();
      return false;
	}
  });
}
/************************** End - Diamond Polish Filter **************************/

/************************** Start - Diamond Symmetry Filter **************************/
function symmetry_slider_render(start,end,option){
  var symmetryHeadTitle = 'Symmetry:';  
  var symmetrySliderDefaultMax = jQuery("#symmetry-slider-default-max").val();
  //session Symmetry filter selected
  var isSelected = false;
  if(start != 0 || end != symmetrySliderDefaultMax){
     isSelected = true;
  }  
  var selected_values = getFilterValues(min_symmetry,max_symmetry,'symmetry');
  if(selected_values[0] == selected_values[1]){
    var symmetryTitle = symmetryHeadTitle+' '+selected_values[1];
  }else{
    var symmetryTitle = symmetryHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }
  setSelectedFilter(symmetryTitle,"symmetry_slider_render('0', "+symmetrySliderDefaultMax+",'false')",isSelected,'symmetry');
  //end

  jQuery( "#symmetry_range" ).slider({ 
    range: true,
    values: [start, end],
    min: 0,
    max: symmetrySliderDefaultMax,
    step: 1, 
    slide: function( event, ui ) {          
      if ((ui.values[0]) >= (ui.values[1])) {
        return false;
      }         
      jQuery( "#symmetry-min-value" ).val(ui.values[0]);
      jQuery( "#symmetry-max-value" ).val(ui.values[1]);       
    },
    change: function( event, ui ) {  
      emptyResultDiv();      
      jQuery( "#symmetry-min-value" ).val(ui.values[0]);
      jQuery( "#symmetry-max-value" ).val(ui.values[1]);          
      //applied filters 
      var isSelected = false;         
      if(ui.values[0] != 0 || ui.values[1] != symmetrySliderDefaultMax){
        isSelected = true;
      }          
      var selected_values = getFilterValues(ui.values[0],ui.values[1],'symmetry');      
      if(selected_values[0] == selected_values[1]){
        var symmetryTitle = symmetryHeadTitle+' '+selected_values[1];    
      }else{
        var symmetryTitle = symmetryHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
      }
      setSelectedFilter(symmetryTitle,"symmetry_slider_render('0', "+symmetrySliderDefaultMax+",'false')",isSelected,'symmetry');
      //end          
      jQuery('#page_no').val(1);
      jQuery('#pagination').val('');
      graphqlDataCall();
      return false;
    }
  });
}
/************************** End - Diamond Symmetry Filter **************************/
  
function getFilterValues(min_value,max_value,filter) {
  var filterArray = '';
  if(filter == 'cut'){
    filterArray = cut_array;  
  }else if(filter == 'polish'){
    filterArray = polish_array;  
  }else if(filter == 'symmetry'){
    filterArray = symmetry_array;  
  }else if(filter == 'fluorescence'){
    filterArray = fluorescence_array;  
  }else if(filter == 'clarity'){
    filterArray = clarity_array;  
  }else if(filter == 'color'){
    filterArray = color_array;  
  }else if(filter == 'intensity'){
    filterArray = intensity_array;  
  }

  var i=0;
  var selected_values = [];
  $.each(filterArray, function(key,cut){
    if(i == min_value){
      selected_values.push(key);
    }
    if(i == max_value-1){
      selected_values.push(key);
    }
    i++;     
  });  
  return selected_values;
}

/***Diamond sorting Filter Start ***/
function sorting_data(sorting, className) {
    emptyResultDiv();
  
	var sortorder = '';
	var clas = className;

	jQuery('.datagrid-sort').each(function() {
		if (jQuery(this).hasClass('fa-angle-up')) {
			jQuery(this).removeClass('fa-angle-up').addClass('fa-angle-down');
		}
	});

	if ((mySelection[1] == sorting) && (mySelection[2] == 'asc')) {
		sortorder = 'desc';
		jQuery(clas).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
	} else {
		sortorder = 'asc';
		jQuery(clas).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
	}

    //grid view
    var sort_value = ''+sorting+'_'+sortorder;     
    var sort_text = jQuery('.'+sort_value).attr('value'); 
     
    jQuery('.sortvaluename').text(sort_text);  
  
	jQuery('#sort_call').val(sorting);
	jQuery('#sort_dir').val(sortorder);


	mySelection[1] = jQuery('#sort_call').val();
	mySelection[2] = jQuery('#sort_dir').val();
 
	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
	graphqlDataCall();
}
/*** Diamond sorting Filter End ***/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/* useful diamonds functions */
/* get diamond title */
function getDiamondTitle(diamondData, diamondType){
  var diamondTitle = parseFloat(diamondData.caratWeight).toFixed(2) + "-Carat " + diamondData.shape + " Shape";
  if( typeof diamondData.fancyColor != 'undefined' && diamondData.fancyColor != ""){
    diamondTitle += " "+diamondData.fancyColor;
  }
  diamondTitle += " "+diamondType +" Diamond";
  diamondTitle = diamondTitle.replaceAll("  "," ");
  return diamondTitle;
}

/* get diamond details page url */
function getDiamondDetailsPageUrl(diamondData){
  return jQuery("#tps-shopify-store-url").val() + tps_config.urls.ringbuilder_diamond_detail+'?diamond_id='+diamondData.diamondId+'&diamond_type='+diamondData.diamondType;      
}

/* get diamond certificate url; */
function getDiamondCertificateUrl(diamondData){
  var certificateUrl = "";
  switch(diamondData.lab){
    case "GIA":
        certificateUrl = 'https://www.gia.edu/report-check?reportno='+diamondData.certificateNumber+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
        break;
    case "IGI":
        certificateUrl = 'https://www.igi.org/verify-your-report/?r='+diamondData.certificateNumber;
        break;
    case "HRD":
        certificateUrl = 'https://my.hrdantwerp.com/Download/GetGradingReportPdf/?reportNumber='+diamondData.certificateNumber+'&printDocumentType=LabGrownCert';
        break;
    case "AGS":
        certificateUrl = 'https://agslab.com/ym-vdgr/en-us/diamonds/'+diamondData.certificateNumber+'/grading-report';
        break;
    default:
        certificateUrl = diamondData.certificateFile;
  }
  return certificateUrl;
}

/* get diamond type label */
function getDiamondTypeLabel(diamondType){
  var diamondTypeLabel = "";
  switch(diamondType){
    case "natural-white" : 
      diamondTypeLabel = 'Natural';
      break;
    case "lab-white" : 
      diamondTypeLabel = 'Lab';
      break;
    case "natural-fancy" : 
      diamondTypeLabel = 'Natural';
      break;
    case "lab-fancy" : 
      diamondTypeLabel = 'Lab';
      break;
    default :         
      diamondTypeLabel = '';
  }
  return diamondTypeLabel;
}

/* get diamond listing url based on type label */
function getDiamondListingUrlByDiamondType(diamondType){
  var diamondListingUrl = "";
  switch(diamondType){
    case "natural-white" : 
      diamondListingUrl = tps_config.urls.ringbuilder_natural_white_diamond_listing;
      break;
    case "lab-white" : 
      diamondListingUrl = tps_config.urls.ringbuilder_lab_white_diamond_listing;
      break;
    case "natural-fancy" : 
      diamondListingUrl = tps_config.urls.ringbuilder_natural_colored_diamond_listing;
      break;
    case "lab-fancy" : 
      diamondListingUrl = tps_config.urls.ringbuilder_lab_colored_diamond_listing;
      break;
    default :         
      diamondListingUrl = tps_config.urls.ringbuilder_natural_white_diamond_listing;
  }
  return diamondListingUrl;
}

/* get diamond price currency wise */
function getDiamondPrice(diamondData){     
  var currency_rate = Shopify.currency.rate;
  var graphqlCurrencyCode = capitalizeFirstLetter(jQuery("#tps-currency-symbol").val());
  var dia_price = diamondData[`finalPrice${graphqlCurrencyCode}`];
  dia_price = dia_price * currency_rate; 
  dia_price = Math.ceil(dia_price); 
  var diamondPrice = Shopify.formatMoney(dia_price * 100, theme.moneyFormat);
  dia_price = Shopify.formatMoney(dia_price * 100, theme.moneyFormat);
  if(currencyCode == 'USD' || currencyCode == 'HKD' || currencyCode == 'GBP' || currencyCode =='EUR'){
    dia_price = diamondPrice.replace('.00','');
  }
  return dia_price;
}

/* get final price column names in currencies */
function getFinalPriceColumnNamesInCurrencies(){
  var currencyColumns = "";
  availableCurrencies.forEach(function(currency){
    currencyColumns += ' finalPrice' + capitalizeFirstLetter(currency);
  });
  return currencyColumns;
}

/* update breadcrumb title */
function updateBreadcrumbTitle(breadcrumbTitle){
  if(jQuery('.tps-product-details-page-dynamic-title').length){
    jQuery('.tps-product-details-page-dynamic-title').text(breadcrumbTitle);
  }
}

/* update breadcrumb category link */
function updateBreadcrumbCategoryLink(diamondType){
  var breadcrumbLink = getDiamondListingUrlByDiamondType(diamondType);
  if(jQuery('#tps-diamond-details-breadcrumb-link').length){
    jQuery('#tps-diamond-details-breadcrumb-link').attr('href', breadcrumbLink);
  }
}

/*** Capitalized first letter from string start ***/
function capitalizeFirstLetter(str){
  return (str != "" && str != null) ? (str[0].toUpperCase() + (str.substr(1,str.length)).toLowerCase()) : '';
}
/*** End ***/

/*** Mobile Gallery Functinality Start ***/ 
$(document).on("click", ".tps_dots", function() {
  var data_thumb = jQuery(this).attr("data-thumb");  
  jQuery(".tps_dots").removeClass("active"); 
  jQuery(this).addClass("active");
  
  jQuery(".tps_mobile_gallery_image").hide(); 
  jQuery(".tps_image_"+data_thumb).show(); 
});
/*** End ***/

jQuery(document).on({
    click : function(e) {
        var toggleDivElement = jQuery(this).data("toggle");
        jQuery(`#${toggleDivElement}`).toggle();
    },
}, '.tps-diamond-listing-sort-dropdown .dropdown-toggle');
